import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Search from "./pages/Search";
import AddItem from "./pages/AddItem";
import EditItem from "./pages/Edititem";
import Products from "./pages/Products";
import SellItem from "./pages/SellItem";
import Transactions from "./pages/Transactions";
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      {isAuthenticated ? (
        <>
          <Navbar/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inventory" element={<Search />} />
            <Route path="/add" element={<AddItem />} />
            <Route path="/edit" element={<EditItem />} />
            <Route path="/sell" element={<SellItem />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/products" element={<Products/>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login onLogin={() => setIsAuthenticated(true)} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
